import React from 'react';

/**
 * CSS mockup of the six volumes, in the product palette.
 * Placeholder until the real box-set render is ready — then swap this
 * component for an <img>.
 */
const volumes = [{
  n: '01',
  title: 'Build the Room',
  weeks: 'Practices 01–15',
  band: 'bg-sage'
}, {
  n: '02',
  title: 'Attack on Your Feet',
  weeks: 'Practices 16–30',
  band: 'bg-block-a'
}, {
  n: '03',
  title: 'Own the Mat',
  weeks: 'Practices 31–45',
  band: 'bg-block-c'
}, {
  n: '04',
  title: 'Chain It Together',
  weeks: 'Practices 46–60',
  band: 'bg-block-b'
}, {
  n: '05',
  title: 'Hold the Line',
  weeks: 'Practices 61–75',
  band: 'bg-smoke'
}, {
  n: '06',
  title: 'Peak for the Postseason',
  weeks: 'Practices 76–90',
  band: 'bg-gold'
}];
export function VolumeStack({
  className = ''
}: {
  className?: string;
}) {
  return <div role="img" aria-label="Wrestling Practice Ready: six volumes, from Build the Room (practices 1–15) to Peak for the Postseason (practices 76–90)" className={`relative w-full select-none ${className}`} data-id="element-314" data-mp="1dqy4zhhto5a7">
      <span aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center font-display font-semibold text-gold/15 leading-none text-[42vw] sm:text-[240px] lg:text-[260px]" data-id="element-315" data-mp="3lguhegn6fm50">
        90
      </span>

      <div className="relative flex items-end justify-center px-2 pb-8 pt-10" data-id="element-316" data-mp="33ei348fdyyp">
        {volumes.map((v, i) => {
        const offset = i - 2.5;
        return <div key={v.n} className="relative -ml-[8%] first:ml-0 w-[25%] aspect-[3/4] overflow-hidden rounded-[6px] bg-cream shadow-cover ring-1 ring-black/5" style={{
          transform: `rotate(${offset * 4.5}deg) translateY(${Math.abs(offset) * 7}px)`,
          zIndex: 10 - Math.round(Math.abs(offset))
        }} data-id="element-317" data-mp="32kuon3mdkekd" data-mpi={i}>
              <div className="h-[40%] bg-plum px-[9%] pt-[11%]" data-id="element-318" data-mp="qvbh1uqs0wie">
                <span className="block text-[clamp(5px,1.3vw,9px)] font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-319" data-mp="vr0ki95x2xjz">
                  Volume {v.n}
                </span>
                <span className="mt-[6%] block font-display text-[clamp(7px,1.7vw,12px)] leading-tight text-white/85" data-id="element-320" data-mp="2nuegh7sk29j5">
                  Wrestling Practice Ready
                </span>
              </div>
              <div className="px-[9%] pt-[10%]" data-id="element-321" data-mp="2wu9v5mlbkmnx">
                <span className="block font-display font-semibold text-plum text-[clamp(8px,2.1vw,15px)] leading-[1.1]" data-id="element-322" data-mp="2wsgjttzrhe9l">
                  {v.title}
                </span>
                <span className="mt-[8%] block text-[clamp(5px,1.2vw,9px)] font-semibold uppercase tracking-[0.14em] text-ink-soft" data-id="element-323" data-mp="24770x6noey3h">
                  {v.weeks}
                </span>
              </div>
              {/* thin mat-circle line, the recurring motif of the volumes */}
              <span className="absolute left-[9%] right-[9%] bottom-[18%] h-px bg-gold" data-id="element-324" data-mp="1qdfmbjv38o0w" />
              <span className={`absolute inset-x-0 bottom-0 h-[8%] ${v.band}`} data-id="element-325" data-mp="1lg61yimk32jx" />
            </div>;
      })}
      </div>
    </div>;
}